import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import { Button } from './ui/Button'
import { LocalizedLink } from './LocalizedLink'
import { Upload, ArrowDown } from 'lucide-react'

export function HeroHome() {
  const { t } = useTranslation()

  return (
    <section className="relative min-h-screen flex items-center justify-center bg-dark overflow-hidden pt-20">
      {/* Background Video - Desktop only */}
      <div className="absolute inset-0 hidden md:block">
        <video
          src="/videos/hero.mp4"
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover"
          style={{ border: 'none' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-dark/60 to-dark" />
      </div>

      {/* Background Image - Mobile fallback */}
      <div className="absolute inset-0 md:hidden">
        <img
          src="/images/backgrounds/background_01.jpg"
          alt=""
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-dark/60 to-dark" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-[1448px] mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
            {t('home.hero.title')}
          </h1>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <p className="text-lg md:text-xl text-gray-300 mb-10 mx-auto" style={{ maxWidth: '768px', width: '100%' }}>
            {t('home.hero.subtitle')}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <LocalizedLink to="contacts">
            <Button size="lg" className="gap-2">
              <Upload className="w-5 h-5" />
              {t('home.hero.ctaPrimary')}
            </Button>
          </LocalizedLink>
          <LocalizedLink to="about">
            <Button variant="outline" size="lg">
              {t('home.hero.ctaSecondary')}
            </Button>
          </LocalizedLink>
        </motion.div>
      </div>

      {/* Scroll Indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.6, delay: 0.8 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2"
      >
        <motion.div
          animate={{ y: [0, 10, 0] }}
          transition={{ duration: 1.5, repeat: Infinity }}
          className="text-white/50"
        >
          <ArrowDown className="w-6 h-6" />
        </motion.div>
      </motion.div>
    </section>
  )
}
